import { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';

import { useInView } from 'react-intersection-observer';

import SliderPlaceholder from '../Slider/SliderPlaceholder';

import './FullScreenPhotoList.scss';

const ROOT_MARGIN_PX = '200px';

const LazyPhoto = forwardRef(
  (
    {
      src,
      className,
      imageClassName = '',
      onImageClick,
      id = '',
      caption = '',
      dataAttributes = {},
      showCaption = false
    },
    reference
  ) => {
    const { ref, inView } = useInView({
      triggerOnce: true,
      rootMargin: ROOT_MARGIN_PX,
      threshold: 0
    });

    const content = inView ? (
      <img
        ref={reference}
        src={src}
        alt={caption ? `${caption} - photo` : 'Photo'}
        loading="lazy"
        className={imageClassName}
        id={id}
      />
    ) : (
      <span ref={reference} id={id}>
        <SliderPlaceholder />
      </span>
    );

    return (
      <div ref={ref} className={className} {...dataAttributes}>
        <button
          type="button"
          onClick={onImageClick}
          className="full-screen-photo-list__image-button"
        >
          {content}
          {showCaption && caption && (
            <span className="full-screen-photo-list__image-caption">
              {caption}
            </span>
          )}
        </button>
      </div>
    );
  }
);

LazyPhoto.displayName = 'LazyPhoto';

LazyPhoto.propTypes = {
  className: PropTypes.string.isRequired,
  imageClassName: PropTypes.string,
  onImageClick: PropTypes.func,
  id: PropTypes.string,
  caption: PropTypes.string,
  src: PropTypes.string.isRequired,
  dataAttributes: PropTypes.shape({}),
  showCaption: PropTypes.bool
};

LazyPhoto.defaultProps = {
  onImageClick: null,
  id: ''
};

export default memo(LazyPhoto);
